import Http from "../utilities/Http";
import {API_ROOT} from "../config";

export default {
    async getSurveyResponses(
        organizationId,
        search = null,
        order = null,
        orderBy = null,
        completedOnly = true,
        completedAfterDate = null,
        completedBeforeDate = null,
        sentAfterDate = null,
        sentBeforeDate = null,
        perPage = null,
        page = null,
        paginated = 1,
        ordering = null
    ) {
        let params = {
            search,
            order,
            orderBy,
            completedOnly: completedOnly ? 1 : 0,
            completedAfterDate,
            completedBeforeDate,
            sentAfterDate,
            sentBeforeDate,
            perPage,
            page,
            paginated
        };

        if (ordering && ordering.length > 0) {
            params.ordering = JSON.stringify(ordering);
        }
        
        let response = await Http().get(API_ROOT + '/organizations/' + organizationId + '/survey-responses', {
            params
        });

        return response.data;
    }
};
